import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/theme';
import { AppProvider } from '@/contexts/AppContext';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const MainLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <ThemeProvider>
      <AppProvider>
        <div className="flex h-screen overflow-hidden">
          <Sidebar collapsed={sidebarCollapsed} />
          <div className="flex flex-col flex-1 overflow-hidden">
            <Header
              sidebarCollapsed={sidebarCollapsed}
              onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
            />
            <main
              className="flex-1 overflow-y-auto"
              style={{ backgroundColor: 'var(--theme-page-background)' }}
            >
              <Outlet />
            </main>
          </div>
        </div>
      </AppProvider>
    </ThemeProvider>
  );
};
